<template>
  <div class="empty-state">
    <div class="empty-state-image">
      <slot name="image"></slot>
    </div>
    <div>
      <FriedH3 class="heading">{{ heading }}</FriedH3>
      <FriedParagraph class="description">{{ description }}</FriedParagraph>
    </div>
    <div class="buttons">
      <slot name="cta"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    heading: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15vh;
  gap: var(--spacing-150);

  .empty-state-image {
    width: 56px;
    height: 56px;

    > * {
      width: 100%;
      height: 100%;
    }
  }

  .heading {
    text-align: center;
    margin-bottom: var(--spacing-50);
  }

  .description {
    text-align: center;
    width: 37.5rem;
  }

  .buttons {
    display: flex;
    column-gap: var(--spacing-50);
  }

  @media only screen and (max-width: $xs) {
    .description {
      width: 100%;
    }
  }
}
</style>
